import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Resource } from './resource';
import { UserRoleList } from '../models/user';
import { ApiParams } from './api-params';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { catchError, concatMap, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { userRoleListActions } from '../actions';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '@content-platform/web-angular-shared-data-access-feature-flag-api';

@Injectable()
export class UserRoleListResource extends Resource<UserRoleList> {
  constructor(http: HttpClient, logger: LoggerService, private apiParams: ApiParams,
    featureFlagSvc: WebAngularSharedDataAccessFeatureFlagApisService) {
    super(http, logger.instance('UserRoleListResource'), featureFlagSvc);
  }

  getUrl(flag) {
    return this.apiParams.getUrl('userRoles', undefined, flag);
  }

  /* 
   Craete the user and then get the user roles.
  */

  createUserAndGetRoles(id: string, loggedInUserId: string) {
    let emptyRoles: UserRoleList = {
      id: null,
      uuid: id,
      roles: [],
      name: localStorage.getItem('user_name') ? localStorage.getItem('user_name') : '',
      lastModifiedBy: loggedInUserId
    };
    return this.create({ ...emptyRoles, uuid: id })
      .pipe(
        concatMap((res) => {
          // remove user from local storage
          localStorage.removeItem('user_name');
          console.log('User Created', res);
          // Again get user profiles api 
          return this.get(id).pipe(
            switchMap((userRoleList: UserRoleList) => {
              console.log('user id', id);
              userRoleList.uuid = id;
              return of(userRoleList);
            }),
            map((userRoleList: UserRoleList) => new userRoleListActions.LoadByIdSuccess(userRoleList)),
            catchError((error) => {
              console.log('eeror', error);
              if (error.includes('404 Not Found')) {
                emptyRoles = {
                  id: null,
                  uuid: id,
                  roles: [],
                };
                return of(new userRoleListActions.LoadByIdSuccess(emptyRoles));
              }
            })
          );
        })
      );
  }
  
  protected transformRequest(userRoleList: UserRoleList): UserRoleList {
    const { id, name, uuid, modifiedDate, lastModifiedBy } = userRoleList;
    const roles = userRoleList.roles.map((role) => ({ id: role.id, name: role.name }));
    return { id, uuid, roles, name, modifiedDate, lastModifiedBy } as UserRoleList;
  }

  get entityName(): string {
    return 'User Role List';
  }
}
